import { Phone, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const detectChurnRiskProactiveRetentionCallAr: TemplateAr = {
  name: 'رصد خطر التسرّب + مكالمة احتفاظ استباقية',
  description:
    'الذكاء الاصطناعي يرصد العملاء المعرّضين للتسرّب ويُطلق مكالمات احتفاظ تلقائياً قبل ما يلغوا.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: Users, label: 'إشارة تسرّب' },
    { icon: Sparkles, label: 'الـ AI يرصد' },
    { icon: Phone, label: 'مكالمة احتفاظ', final: true },
  ],
  detailDescription: {
    paragraph1:
      'اتصل بالعميل قبل ما يلغي، مو بعدها. الـ AI يراقب أنماط الاستخدام، ومشاعر تذاكر الدعم، وتراجع التفاعل، وذكر المنافسين، وإشارات الإلغاء. ولمّا يشوف خطر تسرّب، يجدول مكالمة احتفاظ تلقائياً، وعروضها مخصصة حسب وضع العميل نفسه.',
    paragraph2:
      'درجات خطر التسرّب ونتائج الاحتفاظ توصل للـ CRM أو منصة نجاح العملاء أو أدوات تحليل الإيرادات عندك. والـ AI يتعلّم أي عروض الاحتفاظ تنجح مع كل شريحة، ويحسّن استراتيجيته تلقائياً. والحالة اللي تنقذها تشغّل سير عمل الإعداد، عشان يضمن تفاعلاً طويل الأمد.',
  },
  benefits: [
    'تشوف التسرّب قبل ما يصير',
    'تنقذ عميلاً قيمته ١٠-١٠٠ ضعف تكلفة التدخل',
    'كل عميل يجيه عرض احتفاظ على وضعه',
    'التسرّب غير الطوعي ينزل وتلاحظ الفرق',
    'تعرف ليش العميل يفكّر يغادر',
    'القيمة الدائمة للعميل ترتفع',
  ],
};
